import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Grid, CircularProgress } from '@material-ui/core'
import { useDataApi } from '../../context/DataApiContext'
import { useNotificationsProvider } from '../../context/NotificationsContext'

function DStateLabelComponent({
  onPolling,
  dState,
  label,
  options = { pollingPeriodMs: 1000 },
}) {
  useEffect(() => {
    const intervalId = setInterval(() => onPolling(), options.pollingPeriodMs)
    return () => clearInterval(intervalId)
  }, [options, onPolling])

  useEffect(() => {
    if (dState && dState.outputPayload && dState.outputPayload.url) {
      window.location.replace(dState.outputPayload.url)
    }
  }, [dState])

  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      justify="center"
      spacing={0}
      style={{ minHeight: '100vh' }}
    >
      <Grid item xs={3} alignItems="center" justify="center">
        <Grid item align="center">
          <CircularProgress />
        </Grid>
        <Grid item>{label}</Grid>
      </Grid>
    </Grid>
  )
}

export default function DStatePolling() {
  const { t } = useTranslation()
  const { dataProvider } = useDataApi()
  const { showNotification } = useNotificationsProvider()

  const { stateId } = useParams()
  const [dState, setDState] = useState({})

  const performPolling = () => {
    dataProvider.get(
      `dstate-polling/${stateId}`,
      {},
    ).then((response) => {
      setDState(response.data)
    }).catch(() => showNotification('error', t('errors.api-error')))
  }

  return (
    <DStateLabelComponent
      onPolling={performPolling}
      dState={dState}
      label={t('common.loading')}
    />
  )
}
